<!-- prettier-ignore -->

<div (click)="toggleChatView()" (keydown.enter)="toggleChatView()" role="button" tabindex="0" id="button_container_chat" class="button-chat-icon" [ngClass]="{'hidden' : !dataChatService.hideChat()}">
    <img draggable="false" [src]="dataChatService.chatIcon()" class="show" [alt]="'Chat' | translate">
</div>

@if(dataChatService.showTooltip() && dataChatService.initialMessageCurrentLang()){
    <div id="toasty_container_chat" (click)="hideToolTip()">
        <div class="toasty-wrapper js-toasty-wrapper">
            <div class="toasty js-toasty-close">

                {{dataChatService.initialMessageCurrentLang()}}

                <div class="toasty-close js-toasty-close">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368" style="width: 18px; height: 18px; z-index: -1;">
                        <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"></path>
                    </svg>
                </div>
            </div>
        </div>
    </div>
}

@if(chatID()){
    <div 
      class="chatbot-wrapper" 
      [ngClass]="{'hide-chat': dataChatService.hideChat(), 'full-screen': isFullScreen()}"
    >
        <app-chatbot [chatID]="chatID()"></app-chatbot>
    </div>
}

    
